let SERVER_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
  return JSON.parse(localStorage.getItem("key"));
};

const getUserId = () => {
  return Number(localStorage.getItem("userId"));
};
const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
};
export const addcandidate = (body) => {
    const endpoint = `api/candidate/addcandidate`;
    const url = SERVER_URL + endpoint;
    return fetch(url, {
      method: "POST",
      headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
      body: JSON.stringify({
        ...body,
        created_by: getUserId(),
        created_on: new Date(),
      }),
    })
      .then((res) => res.json())
      .then((data) => data);
};
export const addCandidateRelationship = (body,createdId) => {
  const endpoint = `api/candidate/addcandidate/relationship`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "POST",
    headers: { ...headers},
    body: JSON.stringify({
      ...body,
      created_by: createdId,
      created_on: new Date(),
    }),
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const updateCandidateRelationship = (body,id) => {
  const endpoint = `api/candidate/single/updatecandidate/relationship/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "PUT",
    headers: { ...headers},
    body: JSON.stringify({
      ...body,
      updated_on: new Date(),
    }),
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const updateCandidate = (id,body) => {
    const endpoint = `api/candidate/updatecandidate/${id}`;
    const url = SERVER_URL + endpoint;
    return fetch(url, {
      method: "PUT",
      headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
      body: JSON.stringify({
        ...body,
        updated_by: getUserId(),
        updated_on: new Date(),
      }),
    })
      .then((res) => res.json())
      .then((data) => data);
};
export const httpDeleteFamilyDetails = (id) => {
  const endpoint = "api/candidate/familyPersone/remove/" + id;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "DELETE",
    headers: { ...headers },
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const sendjoiningFrom = (id) => {
  console.log('id set')
  console.log(id)
  const endpoint = `api/candidate/mail/JoiningFrom/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const getNewJoinerDetails = (email) => {

  const endpoint = `api/candidate/new/joinerDetail`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "POST",
    headers: { ...headers },
    body: JSON.stringify({
      email:email
    })
  })
    .then((res) => res.json())
    .then((data) => data.data);
};
export const httpCreateCondidatePersonalDetails = (fromdata,id) => {
  console.log('detlais')
  console.log(fromdata.cancelCheck)
  const endpoint = `api/candidate/updatecandidatepersonalDetails/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "PUT",
    headers: {
      'Accept': 'application/json',
  },
    body: fromdata,
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const sendFormAuthCode = (email) => {

  const endpoint = `api/candidate/check/validatecondidate`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "POST",
    headers: { ...headers },
    body: JSON.stringify({
      email:email
    })
  })
    .then((res) => res.json())
    .then((data) => data.data);
};
/* Add Qualification */

export const addCandidateQualification = (body) => {
 
  const endpoint = `api/candidate/onboarding/addcandidate/qualificationDetails`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "POST",
    headers: { 'Accept': 'application/json' },
    body: body,
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const updateCandidateQualification = (body,id) => {
 
  const endpoint = `api/candidate/onboarding/addcandidate/qualificationDetails/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "PUT",
    headers: { 'Accept': 'application/json' },
    body: body,
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const httpDeleteQualificationDetails = (id) => {
 
  const endpoint = `api/candidate/onboarding/delete/qualificationDetails/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "Delete",
    headers: { ...headers },
  })
    .then((res) => res.json())
    .then((data) => data);
};
/*=============================Add previous employee api==========================*/
export const addCandidatePreviousEmpDetails = (body) => {
 
  const endpoint = `api/candidate/onboarding/addcandidate/PreviousEmpDetails`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "POST",
    headers: { 'Accept': 'application/json' },
    body: body,
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const updateCandidatePreviousEmpDetails = (body,id) => {
  const endpoint = `api/candidate/onboarding/single/updatecandidate/PreviousEmpDetails/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "PUT",
    headers: { 'Accept': 'application/json' },
    body: body,
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const UpdateCandidatePreviousEmpSalarySlip = (body,id) => {
  const endpoint = `api/candidate/onboarding/single/updatecandidate/PreviousEmpSalarySlip/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "PUT",
    headers: { 'Accept': 'application/json' },
    body: body,
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const httpDeletePreviousEmpDetails = (id) => {
  const endpoint = "api/candidate/onboarding/PreviousEmp/remove/" + id;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "DELETE",
    headers: { ...headers },
  })
    .then((res) => res.json())
    .then((data) => data);
};